export enum EventImageConsentEnum {
  NOT_ASKED = 'NOT_ASKED',
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
}

export const EVENT_IMAGE_CONSENT_VALUES: EventImageConsentEnum[] = [
  EventImageConsentEnum.NOT_ASKED,
  EventImageConsentEnum.GRANTED,
  EventImageConsentEnum.DENIED,
];

export const DEFAULT_EVENT_IMAGE_CONSENT = EventImageConsentEnum.NOT_ASKED;

export function toEventImageConsent(
  value: string | null | undefined,
): EventImageConsentEnum {
  return EVENT_IMAGE_CONSENT_VALUES.includes(value as EventImageConsentEnum)
    ? (value as EventImageConsentEnum)
    : DEFAULT_EVENT_IMAGE_CONSENT;
}
